import React from 'react';
import { Link } from 'react-router-dom';
import { SAMPLE_PERSONA_IDS } from '../../lib/numerology/samplePersonas';

/** Marie first (left column), Edgar second (right). */
const SAMPLES = [
  {
    id: SAMPLE_PERSONA_IDS.CURIE,
    name: 'Marie Curie',
    description: 'Analytical focus, persistence, disciplined intelligence',
  },
  {
    id: SAMPLE_PERSONA_IDS.POE,
    name: 'Edgar Allan Poe',
    description: 'Creative intensity, emotional depth, symbolic thinking',
  },
];

/**
 * Study examples — same engine as a personal report; cards only (page supplies title and intro).
 */
export default function NumerologySamplePersonas() {
  return (
    <section className="amm-num-samples-cards" aria-labelledby="amm-num-samples-cards-title">
      <h2 id="amm-num-samples-cards-title" className="visually-hidden">
        Study examples
      </h2>
      <div className="amm-num-samples-cards__grid">
        {SAMPLES.map(({ id, name, description }) => (
          <article key={id} className="amm-num-samples-cards__card">
            <div className="amm-num-samples-cards__card-main">
              <h3 className="amm-num-samples-cards__title">{name}</h3>
              <p className="amm-num-samples-cards__desc">{description}</p>
            </div>
            <div className="amm-num-samples-cards__actions">
              <Link className="amm-button" to={`/numerology/report?sample=${encodeURIComponent(id)}`}>
                Open study example
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
